module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FV5PX/tc-custom/9781626812499.jpg?1734213798149",
      "alt": "This image is the cover for the book Never Let Them See You Cry"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Never Let Them See You Cry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("True stories of crime in Miami by the Pulitzer Prize–winning author of "), _c('i', [_vm._v("The Corpse Had a Familiar Face")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Set against the neon backdrop of the South Florida city where "), _c('i', [_vm._v("Miami Herald")]), _vm._v(" reporter Edna Buchanan covered the police beat for nearly two decades, this memoir collects true tales of both heroes and villains—from the heartbreaking to the heartwarming to the outright hilarious."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “A flurry of cases—of criminal Christmases, historic crimes, homicidal love, cop heroes, rescuers, odd occurrences (such as that of the barbiturate-soaked gunman who took 26 direct hits from cops’ guns and kept shooting until a 27th round took him down) . . . a generous bonanza for crime buffs, presented by one of the sharpest writers in the field.” —"), _c('i', [_vm._v("Kirkus Reviews")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Edna  Buchanan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0